import React from 'react';
import { Link } from 'react-router-dom';
import { PUBLISHING_STAGES_CONFIG } from '@ftt/shared';
import { CheckCircle2, ArrowRight, ShieldCheck, Sparkles, BookOpen } from 'lucide-react';

export const ProcessPage: React.FC = () => {
  return (
    <div className="space-y-16 py-12 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      
      {/* Header */}
      <section className="text-center space-y-4 max-w-3xl mx-auto">
        <span className="text-xs font-mono uppercase tracking-widest text-brand-600 font-bold">
          Transparent Editorial Milestones
        </span>
        <h1 className="text-4xl sm:text-5xl font-serif font-bold text-editorial-dark">
          Our 12-Stage Publishing Process
        </h1>
        <p className="text-slate-600 text-sm sm:text-base leading-relaxed">
          We maintain absolute transparency from the moment your manuscript is received through post-publication support. Every stage is logged and tracked in real-time within our Client Portal.
        </p>
      </section>

      {/* Timeline Steps */}
      <section className="space-y-6 relative before:absolute before:inset-y-0 before:left-6 md:before:left-1/2 before:w-0.5 before:bg-slate-200">
        {PUBLISHING_STAGES_CONFIG.map((stage, idx) => (
          <div
            key={stage.status}
            className={`relative flex flex-col md:flex-row gap-6 items-start ${
              idx % 2 === 0 ? 'md:flex-row-reverse' : ''
            }`}
          >
            {/* Center Marker */}
            <div className="absolute left-6 md:left-1/2 -translate-x-1/2 w-10 h-10 rounded-full bg-white border-4 border-brand-500 flex items-center justify-center font-mono font-bold text-xs text-brand-900 shadow-md z-10">
              {stage.order}
            </div>

            {/* Content Card */}
            <div className="ml-16 md:ml-0 md:w-[calc(50%-2.5rem)] p-6 rounded-xl bg-white border border-editorial-border shadow-xs hover:border-brand-300 transition-all space-y-2">
              <div className="flex items-center justify-between text-xs font-mono text-brand-700 font-bold uppercase">
                <span>Phase {Math.ceil(stage.order / 3)}</span>
                <span>Stage {stage.order} of 12</span>
              </div>
              <h3 className="font-serif text-lg font-bold text-slate-900">
                {stage.label}
              </h3>
              <p className="text-xs sm:text-sm text-slate-600 leading-relaxed font-sans">
                {stage.description}
              </p>
            </div>
          </div>
        ))}
      </section>

      {/* Author Call to Action */}
      <section className="p-8 sm:p-12 rounded-2xl bg-editorial-dark text-white text-center space-y-6">
        <div className="max-w-2xl mx-auto space-y-3">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-slate-100">
            Start Your Journey with For The Truth Publishing
          </h2>
          <p className="text-xs sm:text-sm text-slate-300 font-light">
            Submit your manuscript or publishing proposal for formal assessment by our acquisitions committee.
          </p>
        </div>

        <div>
          <Link
            to="/submit-enquiry"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-lg bg-brand-500 hover:bg-brand-600 text-slate-950 font-bold text-xs shadow-lg transition-all"
          >
            <span>Begin Publishing Enquiry</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>

    </div>
  );
};
